<button mat-icon-button [matMenuTriggerFor]="themeMenu" matTooltip="{{ 'tooltips.Color Schemes' | translate }}">
  <fa-icon icon="fill-drip" size="lg"></fa-icon>
</button>

<mat-menu class="LOSx-theme-picker-menu" #themeMenu="matMenu" x-position="before">
  <mat-grid-list cols="2">
    @for (theme of themes; track theme) {
      <mat-grid-tile>
        <div mat-menu-item (click)="installTheme(theme)">
          <div class="LOSx-theme-picker-swatch">
            @if (currentTheme.href === theme.href) {
              <fa-icon class="LOSx-theme-chosen-icon" icon="check-circle" size="lg"></fa-icon>
            }
            <div class="LOSx-theme-picker-primary" [style.background]="theme.primary"></div>
            <div class="LOSx-theme-picker-accent" [style.background]="theme.accent"></div>
          </div>
        </div>
      </mat-grid-tile>
    }
  </mat-grid-list>
</mat-menu>
